@if (acceptReservation) {
  <div class="layout">
    <div class="layout__header">
      <app-header></app-header>
    </div>
    <div class="layout__content"
  [ngClass]="!isHeaderDisplayed && !showFooter ? 'layout__without-header-footer' :
            (!isHeaderDisplayed ? 'layout__selection-view-without-header' : (!showFooter ? 'layout__height-without-footer' : ''))">
      <ng-scrollbar [disabled]="currentComponentName == componentName.tablesLayout" [ngClass]="{'scroll-disabled': currentComponentName == componentName.tablesLayout }">
        <!-- Need to change the styles based on Merchant portal -->
        <div class="layout__content-padding"
      [ngStyle]="{'font-family':ls.restaurantWidgetSettings$.value.WidgetCustomization.MainContentFont,
      'font-size': ls.restaurantWidgetSettings$.value.WidgetCustomization.MainContentFontSize+'px'}">
          @if (gs.message.message) {
            <app-message [messageInfo]="gs.message" (closeEvent)="closeMessage($event)"></app-message>
          }
          @if (currentComponentName != componentName.tablesLayout) {
            <div class="layout__banner-image" [ngClass]="{'layout__banner-image-height':hideImage}">
              <!-- <app-message [messageInfo]="ls.message" (closeEvent)="closeMessage($event)"></app-message> -->
              @if (!hideImage) {
                <img src="{{imageUrl}}"  (error)="loadDefaultImage($event)" alt="{{ls.restaurantWidgetSettings$.value.RestaurantName}} banner-img" tabindex="0">
              }
              <!-- <img @if (!imgAvailable) { src="../../assets/images/Cork-Tables.jpg" alt="banner-img"> } -->
              @if (ls.restaurantWidgetSettings$.value.WidgetCustomization.DisplayRestaurantName || ls.restaurantWidgetSettings$.value.WidgetCustomization.DisplayRestaurantAddress) {
                <div>
                  @if (hideImage) {
                    <div class="layout__default-data" tabindex="0">
                      @if (ls.restaurantWidgetSettings$.value.WidgetCustomization.DisplayRestaurantName) {
                        <div class="layout__property-name property-header" title="{{ls.restaurantWidgetSettings$.value.RestaurantName}}">{{ls.restaurantWidgetSettings$.value.RestaurantName}}</div>
                      }
                      @if (ls.restaurantWidgetSettings$.value.WidgetCustomization.DisplayRestaurantAddress) {
                        <span class="reservation-address">
                          <em class="icon-Location layout__location-icon"></em>{{ls.restaurantWidgetSettings$.value.Street1}}{{ls.restaurantWidgetSettings$.value.Street2}}, {{ls.restaurantWidgetSettings$.value.City}}, {{ls.restaurantWidgetSettings$.value.Country}}</span>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
            <section class="layout__template-container" [ngClass]="{'layout__selection-view':currentComponentName == componentName.tablesLayout,'layout__template-container-height':hideImage}">
              <!-- <div class="layout__remaining-time-indicator" @if (ls.showTimer) {
              <div class="focused-sub-header" [ngStyle]="{'color':ls.restaurantWidgetSettings$.value.WidgetCustomization.WidgetLinkColor}">{{ls.minutes}} <span class="error-message" >{{'mins' | translate}}</span> {{ls.seconds}} <span class="error-message">{{'secs' | translate}}</span></div>
              <div class="default-form-field layout__time-left-text">{{'leftForBooking' | translate}}</div>
            </div> -->
            <ng-container #comp *ngComponentOutlet="currentComponent"></ng-container>
            <!--<div @if (componentArray.indexOf(currentComponentName) == -1) {
            <ng-container #temp *ngTemplateOutlet="currentComponent"></ng-container>
          </div> -->
        </section>
      </div>
    </ng-scrollbar>
  </div>
  @if (showFooter) {
    <div class="layout__footer">
      <app-footer></app-footer>
    </div>
  }
</div>
}
@if (!acceptReservation && outOfServiceMessage) {
  <div>
    <app-message [messageInfo]="outOfServiceMessage" (closeEvent)="closeMessage($event)"></app-message>
  </div>
}